import { render } from "./view-signatory-modal.html?vue&type=template&id=910853fe&scoped=true&ts=true&external"
import script from "./view-signatory-modal.ts?vue&type=script&lang=ts&external"
export * from "./view-signatory-modal.ts?vue&type=script&lang=ts&external"

import "./view-signatory-modal.scss?vue&type=style&index=0&id=910853fe&scoped=true&lang=scss&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-910853fe"]])

export default __exports__